/**
 * Maps Contentful focus area labels to Contentful Image API focus parameter values.
 * Kept in a shared util (no "use client") so it can be used from both server and client.
 */
export function formatFocusArea(focusArea: string): string {
  switch (focusArea) {
    case "Left Top":
      return "top_left"
    case "Top":
      return "top"
    case "Right Top":
      return "top_right"
    case "Left Middle":
      return "left"
    case "Center":
      return "center"
    case "Right Middle":
      return "right"
    case "Left Bottom":
      return "bottom_left"
    case "Bottom":
      return "bottom"
    case "Right Bottom":
      return "bottom_right"
    default:
      return "center"
  }
}

/**
 * Maps Contentful focus area labels to CSS object-position / background-position values.
 */
export function focusAreaToCssPosition(focusArea?: string): string {
  switch (focusArea) {
    case "Left Top":
      return "left top"
    case "Top":
      return "center top"
    case "Right Top":
      return "right top"
    case "Left Middle":
      return "left center"
    case "Right Middle":
      return "right center"
    case "Left Bottom":
      return "left bottom"
    case "Bottom":
      return "center bottom"
    case "Right Bottom":
      return "right bottom"
    case "Center":
    default:
      return "center center"
  }
}
